<template>
    <ansWrapper v-if="wrapperVisible" :visible="wrapperVisible" :trigger-element="wrapperConfig.triggerElement" @close="handleClose">
        <component
            :is="wrapperConfig.component"
            v-bind="wrapperConfig.componentProps"
            @close="handleClose"
            @select="handleSelect"
            v-on="eventHandlers"
        />
    </ansWrapper>
</template>

<script>
/**
 * ****************************************************************************
 * @description     :   Global Wrapper Component
 * @created at      :   2025/09/29
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import { mapMutations, mapState } from 'vuex';
import ansWrapper from '@/components/ansWrapper/index.vue';

export default {
    name: 'GlobalWrapper',
    components: {
        ansWrapper
    },
    computed: {
        ...mapState('app', {
            wrapperVisible: (state) => state.globalWrapper.visible,
            wrapperConfig: (state) => ({
                component: state.globalWrapper.component,
                componentProps: state.globalWrapper.componentProps,
                triggerElement: state.globalWrapper.triggerElement,
                onClose: state.globalWrapper.onClose,
                onSelect: state.globalWrapper.onSelect
            }),
            eventHandlers: (state) => state.globalWrapper.eventHandlers || {}
        })
    },
    methods: {
        ...mapMutations('app', ['hideGlobalWrapper']),
        handleClose() {
            if (this.wrapperConfig.onClose && typeof this.wrapperConfig.onClose === 'function') {
                this.wrapperConfig.onClose();
            }
            this.hideGlobalWrapper();
        },
        handleSelect(data) {
            if (this.wrapperConfig.onSelect && typeof this.wrapperConfig.onSelect === 'function') {
                this.wrapperConfig.onSelect(data);
            }
            this.hideGlobalWrapper();
        }
    }
};
</script>
